import React from 'react'
import './Styles/Footer.css'



function Footer() {
  return (
    <div class="footer">
  <p>About</p>
  <p>Advertising</p>
  <p>Business</p>
  <p>How Search Works</p>
</div>
  )
}

export default Footer